module.exports = __webpack_public_path__ + "static/img/location.99637f85.png";